<template>
  <div class="Description" :class="{ 'use_bkg': use_bkg }">
    <div class="Description__container" v-html="txt"/>
  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'Description',
  props: ['indice'],
  data: ()=>({
    txt: 'Lorem ipsum',
    use_bkg: false
  }),
  mounted() {
    if(this.indice)
      this.txt = this.trans('GLOBAL.'+ this.indice)
    this.use_bkg = this.$route.params.section == undefined
                || this.$route.params.section == 'recenter'
                || this.$route.params.section == 'weave' ? true : false

  },  

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Description
  text-align center
  font-size 0.94em
  line-height 1.31em
  position relative
  height 14%
  width 83%
  border-top 1px solid purple
  border-bottom 1px solid purple
  display flex
  justify-content center
  align-items center
  font-family Raleway
  font-weight 600
  z-index 400
  color white
  background transparent

  &.use_bkg
    background rgba(#0000, .35)
    background linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .35) 10%, rgba(0, 0, 0, .35) 90%, rgba(0, 0, 0, 0) 100%)

  &__container
    & span 
      font-weight 900

</style>


